import { EFrequency } from '@/context/borrower';

export function getMonthlyAmount(
    frequency: EFrequency | null | undefined,
    amount: number | null | undefined
): number {
    if (frequency === null || frequency === undefined) {
        return 0;
    }
    if (amount === null || amount === undefined) {
        return 0;
    }

    let result: number;
    switch (frequency) {
        case EFrequency.WEEKLY:
            result = amount * 4.3;
            break;
        case EFrequency.FORTNIGHTLY:
            result = amount * 2;
            break;
        case EFrequency.MONTHLY:
            result = amount;
            break;
        default:
            return 0;
    }

    return Number(result.toFixed(2));
}
